import { AIMarkdownText } from '@/pages/Chat/components/Chat/AIMarkdownText';
import { parseMarkdownIntoBlocks } from '@/utils/aiUtils';
import { memo, useMemo } from 'react';
import { Source } from './ChatContext';

/**
 * See https://ai-sdk.dev/cookbook/next/markdown-chatbot-with-memoization
 */

const MemoizedMarkdownBlock = memo(
  ({
    content,
    sources,
    size,
    tableView,
  }: {
    content: string;
    sources: Source[];
    size?: 'base' | 'sm';
    tableView?: boolean;
  }) => {
    return (
      <AIMarkdownText
        tableCopy
        tableView={tableView}
        sources={sources}
        size={size}
      >
        {content}
      </AIMarkdownText>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.content !== nextProps.content) {
      return false;
    }
    if (prevProps.sources !== nextProps.sources) {
      return false;
    }
    return true;
  }
);

export const MemoizedMarkdown = memo(
  ({
    content,
    sources,
    size,
    tableView,
  }: {
    content: string;
    sources: Source[];
    size?: 'base' | 'sm';
    tableView?: boolean;
  }) => {
    const blocks = useMemo(() => parseMarkdownIntoBlocks(content), [content]);

    return blocks.map((block, index) => (
      <MemoizedMarkdownBlock
        content={block}
        sources={sources}
        key={`block_${index}`}
        size={size}
        tableView={tableView}
      />
    ));
  }
);
